const NOTIFICATIONS_ENABLED_ID = "notificationsEnabled";

export const getNotificationsEnabled = () =>
  localStorage.getItem(NOTIFICATIONS_ENABLED_ID) === "true";

export const saveNotificationsEnabled = (enabled: boolean) =>
  localStorage.setItem(NOTIFICATIONS_ENABLED_ID, String(enabled));

export const removeNotificationsEnabled = () =>
  localStorage.removeItem(NOTIFICATIONS_ENABLED_ID);
